module.exports = __webpack_public_path__ + "static/media/stijn-bessem-case-vodafonecvm-00.2@2x.ddab37f8.jpg";